@let isPlacesApiLoaded = isGooglePlacesApiLoaded$ | async;

@if (isPlacesApiLoaded === null) {
  <div class="spinner-container">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
} @else {
  <mat-form-field [class]="cssClass" appearance="outline">
    <mat-label>{{ label }}</mat-label>

    @if (isPlacesApiLoaded === true) {
      <input
        matInput
        [formControl]="control"
        [placeholder]="placeholder"
        [matAutocomplete]="autocompleteRef"
        ngxGoogleMapsPlacesAutocomplete
        #placesAutocomplete="ngxGoogleMapsPlacesAutocomplete"
        [placesAutocompleteDebounceTime]="debounceTime"
        [placesAutocompleteRequest]="placesAutocompleteRequest"
        (placeDetailsLoad)="handlePlaceDetailsLoad($event)"
      />
      <mat-autocomplete 
        autoActiveFirstOption 
        #autocompleteRef="matAutocomplete" 
        [displayWith]="displayWithFn">
        @for (option of placesAutocomplete.options$(); track option.prediction.placeId; let isLast = $last) {
          <mat-option [value]="option">
            <div matLine [innerHtml]="option.formattedMainHtml"></div>
            <small matLine [innerHtml]="option.formattedSecondaryHtml"></small>
          </mat-option>
          @if (!isLast) {
            <mat-divider></mat-divider>
          }
        }
      </mat-autocomplete>
    }

    @if (isPlacesApiLoaded === false) {
      <input matInput [formControl]="control" [placeholder]="fallbackPlaceholder" />
    }

    <mat-error *ngIf="control?.errors | hasControlError: ['required']">
      {{ label }} is required.
    </mat-error>
    <mat-error *ngIf="control?.errors | hasControlError: ['minlength']">
      {{ label }} is too short.
    </mat-error>
    <mat-error *ngIf="control?.errors | hasControlError: ['maxlength']">
      {{ label }} is too long.
    </mat-error>
    <mat-error *ngIf="control?.errors | hasControlError: ['pattern']:ConditionOperator.Only">
      Incorrect {{ label.toLowerCase() }}.
    </mat-error>

    <ng-content></ng-content>
  </mat-form-field>
}